import filter from 'lodash/filter';
import orderBy from 'lodash/orderBy';

export function processAndSetData(
  rawEquipmentData: any[],
  rawGeofenceData: any[],
  setData: React.Dispatch<React.SetStateAction<any>>,
  redirectToIndex: () => void,
  equipmentId?: string,
) {
  const equipmentMachines = filter(rawEquipmentData, e => e.type === 'machine');
  const equipmentAttatchments = filter(
    rawEquipmentData,
    e => e.type !== 'machine',
  );

  const sortedEquipmentMachines = orderBy(
    equipmentMachines,
    e => (e.nickName || e.model).toLowerCase() || !e.hasTelematics,
    ['asc'],
  );
  const sortedEquipmentAttatchments = orderBy(
    equipmentAttatchments,
    e => (e.nickName || e.model).toLowerCase(),
    ['asc'],
  );

  const orderedData = [
    ...sortedEquipmentMachines,
    ...sortedEquipmentAttatchments,
  ];

  const orderedGeofenceData = orderBy(
    rawGeofenceData,
    e => e.description.toLowerCase(),
    ['asc'],
  );

  const equipmentIndex = orderedData.findIndex(e => e.id === equipmentId);
  const fetchedAt = Date.now();

  setData(prevData => ({
    ...prevData,
    geofenceList: orderedGeofenceData,
    equipmentList: orderedData,
    ...(equipmentIndex >= 0
      ? {
          selectedIndex: equipmentIndex,
          selectedEquipment: orderedData[equipmentIndex],
        }
      : {
          selectedIndex: 0,
          selectedEquipment: orderedData && orderedData[0],
        }),
    selectedIndex: 0,
    selectedEquipment: orderedData && orderedData[0],
    fetchedAt,
    isInitialized: true,
    rawEquipmentList: rawEquipmentData,
    rawGeofenceList: rawGeofenceData,
  }));

  if (equipmentIndex < 0 && !!equipmentId) {
    redirectToIndex();
  }
}
